export const columns = [
  {
    title: "Ações",
    key: "actions",
    sortable: false
  },
  {
    title: "Data",
    key: "day",
    sortable: false
  },
  {
    title: "Nome",
    key: "discipline_name",
    sortable: false
  },
  {
    title: "Local",
    key: "venue_name",
    sortable: false
  },
  {
    title: "Nome do Evento",
    key: "event_name",
    sortable: false
  },
  {
    title: "Status",
    key: "status",
    sortable: false
  },
];
